// import React, { useState, useEffect } from 'react';

// import { Plus, Trash2, Calendar, ChevronDown, BarChart3, LineChart as LineChartIcon, Download } from 'lucide-react';
// import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
// import Button from '../../../components/ui/Button';

// const PrimaryGraphCard = () => {
//   const [graphs, setGraphs] = useState([{ id: 1, metric: 'Total Calls', chartType: 'line', breakdown: 'Day' }]);
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showDateDropdown, setShowDateDropdown] = useState(false);
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [graphData, setGraphData] = useState({});
//   const [customStartDate, setCustomStartDate] = useState('');
// const [customEndDate, setCustomEndDate] = useState('');


// useEffect(() => {
//   const fetchAllGraphs = async () => {
//     for (const graph of graphs) {
//       const data = await fetchGraphData(graph, dateFilter, customStartDate, customEndDate);
//       setGraphData(prev => ({ ...prev, [graph.id]: data }));
//     }
//   };

//   fetchAllGraphs();
// }, [
//   graphs.map(g => g.metric + '-' + g.breakdown).join('|'),
//   dateFilter,
//   customStartDate,
//   customEndDate
// ]);





//   const dateFilterOptions = [
//     'Today',
//     'Yesterday',
//     'Last 7 Days',
//     'Last 14 Days',
//     'Last Month',
//     'Custom Range'
//   ];

//   const metricOptions = [
//     'Total Calls',
//     'Total Minutes',
//     'Avg Call Duration',
//     'Unique Customers',
//     'Tickets Raised',
//     'Emails Sent',
//     'Human Escalation %',
//     'Human Escalation Volume',
//     'AI Resolution Rate',
//     'Avg Response Time',
//     'Customer Satisfaction'
//   ];

//   const breakdownOptions = ['Day', 'Week', 'Month', 'Year'];

//   const generateMockData = (breakdown) => {
//     const dataMap = {
//       Day: [
//         { period: 'Day 1', value: 1842 },
//         { period: 'Day 2', value: 2156 },
//         { period: 'Day 3', value: 1923 },
//         { period: 'Day 4', value: 2341 },
//         { period: 'Day 5', value: 2089 },
//         { period: 'Day 6', value: 1567 },
//         { period: 'Day 7', value: 1929 }
//       ],
//       Week: [
//         { period: 'Week 1', value: 8234 },
//         { period: 'Week 2', value: 9123 },
//         { period: 'Week 3', value: 8756 },
//         { period: 'Week 4', value: 9845 }
//       ],
//       Month: [
//         { period: 'Jan', value: 32456 },
//         { period: 'Feb', value: 35678 },
//         { period: 'Mar', value: 38234 },
//         { period: 'Apr', value: 36789 },
//         { period: 'May', value: 39456 },
//         { period: 'Jun', value: 41234 }
//       ],
//       Year: [
//         { period: '2021', value: 345678 },
//         { period: '2022', value: 389234 },
//         { period: '2023', value: 423456 },
//         { period: '2024', value: 456789 }
//       ]
//     };
//     return dataMap?.[breakdown] || dataMap?.Day;
//   };


// const METRIC_MAP = {
//   'Total Calls': 'TOTAL_CALLS',
//   'Total Minutes': 'TOTAL_MINUTES',
//   'Avg Call Duration': 'AVG_CALL_DURATION',
//   'Unique Customers': 'UNIQUE_CUSTOMERS',
//   'Tickets Raised': 'TICKETS_RAISED',
//   'Emails Sent': 'EMAILS_SENT',
//   'Human Escalation %': 'HUMAN_ESCALATION_PERCENT',
//   'Human Escalation Volume': 'HUMAN_ESCALATION_VOLUME',
//   'AI Resolution Rate': 'AI_RESOLUTION_RATE',
//   'Avg Response Time': 'AVG_RESPONSE_TIME',
//   'Customer Satisfaction': 'CUSTOMER_SATISFACTION'
// };

// const BREAKDOWN_MAP = {
//   Day: 'DAY',
//   Week: 'WEEK',
//   Month: 'MONTH',
//   Year: 'YEAR'
// };

// const getFromToDates = (selection, customStart, customEnd) => {
//   const now = new Date();
//   let from = new Date();
//   let to = new Date();

//   switch (selection) {
//     case 'Today':
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;
//     case 'Yesterday':
//       from.setDate(now.getDate() - 1);
//       from.setHours(0, 0, 0, 0);
//       to.setDate(now.getDate() - 1);
//       to.setHours(23, 59, 59, 999);
//       break;
//     case 'Last 7 Days':
//       from.setDate(now.getDate() - 6);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;
//     case 'Last 14 Days':
//       from.setDate(now.getDate() - 13);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;
//     case 'Last Month':
//       from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//       to = new Date(now.getFullYear(), now.getMonth(), 0);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;
//     case 'Custom Range':
//       if (!customStart || !customEnd) return null;
//       from = new Date(customStart);
//       from.setHours(0, 0, 0, 0);
//       to = new Date(customEnd);
//       to.setHours(23, 59, 59, 999);
//       break;
//     default:
//       from = new Date('2024-01-01');
//       to = now;
//   }

//   const format = (date) => date.toISOString().split('.')[0]; // "YYYY-MM-DDTHH:mm:ss"

//   return { from: format(from), to: format(to) };
// };


// //   const fetchGraphData = async (graph) => {
// //   try {
// //     const metric = METRIC_MAP[graph.metric];
// //     const breakdown = BREAKDOWN_MAP[graph.breakdown];

// //     console.log(metric)

// //     const res = await fetch(
// //       `http://localhost:8080/api/v1/dashboard/metrics?from=2024-12-01T00:00:00&to=2026-12-31T23:59:59&breakdown=${breakdown}&merchantId=M26686IMS&metric=${metric}`,
// //       {
// //         headers: {
// //           Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwiaWF0IjoxNzY4Mzk3NjEwLCJleHAiOjE3OTk5MzM2MTB9.gvjuyisvIcI2K4zrtt-UbsDhGDkZhGRmLM-zf3qyovw'
// //         }
// //       }
// //     );

// //     const json = await res.json();
// //     return json?.data?.data || [];
// //   } catch (err) {
// //     console.error(err);
// //     return [];
// //   }
// // };

// const fetchGraphData = async (graph, dateSelection, customStart, customEnd) => {
//   try {
//     const metric = METRIC_MAP[graph.metric];
//     const breakdown = BREAKDOWN_MAP[graph.breakdown];

//     const { from, to } = getFromToDates(dateSelection, customStart, customEnd);

//     if (!from || !to) return [];

//     const res = await fetch(
//       `http://localhost:8080/api/v1/dashboard/metrics?from=${from}&to=${to}&breakdown=${breakdown}&merchantId=M26686IMS&metric=${metric}`,
//       {
//         headers: {
//           Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwiaWF0IjoxNzY4Mzk3NjEwLCJleHAiOjE3OTk5MzM2MTB9.gvjuyisvIcI2K4zrtt-UbsDhGDkZhGRmLM-zf3qyovw'
//         }
//       }
//     );

//     const json = await res.json();
//     return json?.data?.data || [];
//   } catch (err) {
//     console.error(err);
//     return [];
//   }
// };


//   const handleAddGraph = () => {
//     if (graphs?.length < 4) {
//       setGraphs([...graphs, { id: Date.now(), metric: 'Total Calls', chartType: 'line', breakdown: 'Day' }]);
//     }
//   };

//   const handleDeleteGraph = (id) => {
//     if (graphs?.length > 1) {
//       setGraphs(graphs?.filter(graph => graph?.id !== id));
//     }
//   };

//   const handleMetricChange = (id, metric) => {
//     setGraphs(graphs?.map(graph => graph?.id === id ? { ...graph, metric } : graph));
//   };

//   const handleChartTypeToggle = (id) => {
//     setGraphs(graphs?.map(graph => 
//       graph?.id === id ? { ...graph, chartType: graph?.chartType === 'line' ? 'bar' : 'line' } : graph
//     ));
//   };

//   const handleBreakdownChange = (id, breakdown) => {
//     setGraphs(graphs?.map(graph => graph?.id === id ? { ...graph, breakdown } : graph));
//   };

//   const handleDownloadReport = () => {
//     console.log('Downloading Primary Graph Analytics Report...');
//     // Report download logic will be implemented here
//   };

//   const handleDateFilterChange = (option) => {
//     if (option === 'Custom Range') {
//       setShowCustomRange(true);
//     } else {
//       setShowCustomRange(false);
//     }
//     setDateFilter(option);
//     setShowDateDropdown(false);
//   };

//   return (
//     <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 shadow-lg p-6 mb-6 md:mb-8 hover:shadow-xl transition-all duration-300">
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
//         <div>
//           <h2 className="text-xl font-semibold text-foreground mb-1">Primary Graph Analytics</h2>
//           <p className="text-sm text-muted-foreground">Visualize key metrics with customizable breakdowns</p>
//         </div>
        
//         <div className="flex items-center gap-3">
//           <button
//             onClick={handleDownloadReport}
//             className="flex items-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md"
//           >
//             <Download className="w-4 h-4" />
//             <span>Download Report</span>
//           </button>
          
//           <div className="relative">
//             <button
//               onClick={() => setShowDateDropdown(!showDateDropdown)}
//               className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-primary transition-all duration-200 text-sm font-medium text-foreground shadow-sm hover:shadow-md"
//             >
//               <Calendar className="w-4 h-4 text-primary" />
//               <span>{dateFilter}</span>
//               <ChevronDown className="w-4 h-4 text-muted-foreground" />
//             </button>
            
//             {showDateDropdown && (
//               <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden animate-fadeIn">
//                 {dateFilterOptions?.map((option) => (
//                   <button
//                     key={option}
//                     onClick={() => handleDateFilterChange(option)}
//                     className={`w-full text-left px-4 py-2.5 text-sm hover:bg-blue-50 transition-colors ${
//                       dateFilter === option ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-foreground'
//                     }`}
//                   >
//                     {option}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       {showCustomRange && (
//         <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 animate-fadeIn">
//           <div className="flex flex-col md:flex-row gap-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium text-foreground mb-2">Start Date</label>
//               <input
//                 type="date"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                         value={customStartDate}
//           onChange={(e) => setCustomStartDate(e.target.value)}
//               />
//             </div>
//             <div className="flex-1">
//               <label className="block text-sm font-medium text-foreground mb-2">End Date</label>
//               <input
//                 type="date"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                value={customEndDate}
//           onChange={(e) => setCustomEndDate(e.target.value)}
//               />
//             </div>
//             <div className="flex items-end">
//               <Button className="px-6 shadow-md hover:shadow-lg transition-shadow"
//                         onClick={() => {
//             // Re-fetch graphs with the custom range
//             graphs.forEach(async (graph) => {
//               const data = await fetchGraphData(graph, 'Custom Range', customStartDate, customEndDate);
//               setGraphData(prev => ({ ...prev, [graph.id]: data }));
//             });
//             setShowCustomRange(false);
//           }}
//               >
//                 Apply</Button>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="space-y-6">
//         {graphs?.map((graph, index) => (
//           <div
//             key={graph?.id}
//             className="bg-white rounded-lg border border-gray-200 p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:border-primary"
//           >
//             <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-5">
//               <div className="flex items-center gap-3">
//                 <select
//                   value={graph?.metric}
//                   onChange={(e) => handleMetricChange(graph?.id, e?.target?.value)}
//                   className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm font-medium bg-white hover:border-primary transition-all cursor-pointer shadow-sm"
//                 >
//                   {metricOptions?.map((metric) => (
//                     <option key={metric} value={metric}>{metric}</option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex items-center gap-3">
//                 <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
//                   {breakdownOptions?.map((option) => (
//                     <button
//                       key={option}
//                       onClick={() => handleBreakdownChange(graph?.id, option)}
//                       className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
//                         graph?.breakdown === option
//                           ? 'bg-primary text-white shadow-md'
//                           : 'text-gray-600 hover:bg-gray-200'
//                       }`}
//                     >
//                       {option}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => handleChartTypeToggle(graph?.id)}
//                   className="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-lg hover:from-blue-600 hover:to-indigo-600 transition-all duration-200 text-sm font-medium shadow-md hover:shadow-lg"
//                 >
//                   {graph?.chartType === 'line' ? (
//                     <><LineChartIcon className="w-4 h-4" /> Line</>
//                   ) : (
//                     <><BarChart3 className="w-4 h-4" /> Bar</>
//                   )}
//                 </button>

//                 {graphs?.length > 1 && (
//                   <button
//                     onClick={() => handleDeleteGraph(graph?.id)}
//                     className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200 hover:shadow-md"
//                     title="Delete Graph"
//                   >
//                     <Trash2 className="w-4 h-4" />
//                   </button>
//                 )}
//               </div>
//             </div>

//             <div className="h-80">
//               <ResponsiveContainer width="100%" height="100%">
//                 {graph?.chartType === 'line' ? (
//                   <LineChart data={graphData[graph.id] || []}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis 
//                       dataKey="period" 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <YAxis 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <Tooltip 
//                       contentStyle={{
//                         backgroundColor: 'white',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '8px',
//                         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//                       }}
//                     />
//                     <Legend />
//                     <Line 
//                       type="monotone" 
//                       dataKey="value" 
//                       stroke="#3b82f6" 
//                       strokeWidth={3}
//                       dot={{ fill: '#3b82f6', r: 5 }}
//                       activeDot={{ r: 7, fill: '#1e40af' }}
//                       name={graph?.metric}
//                     />
//                   </LineChart>
//                 ) : (
//                   <BarChart data={graphData[graph.id] || []}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis 
//                       dataKey="period" 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <YAxis 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <Tooltip 
//                       contentStyle={{
//                         backgroundColor: 'white',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '8px',
//                         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//                       }}
//                     />
//                     <Legend />
//                     <Bar 
//                       dataKey="value" 
//                       fill="#3b82f6" 
//                       radius={[8, 8, 0, 0]}
//                       name={graph?.metric}
//                     />
//                   </BarChart>
//                 )}
//               </ResponsiveContainer>
//             </div>
//           </div>
//         ))}

//         {graphs?.length < 4 && (
//           <button
//             onClick={handleAddGraph}
//             className="w-full p-6 rounded-lg border-2 border-dashed border-gray-300 hover:border-primary hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-300 flex flex-col items-center justify-center gap-3 text-muted-foreground hover:text-primary group"
//           >
//             <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center group-hover:from-blue-200 group-hover:to-indigo-200 transition-all duration-300 shadow-md group-hover:shadow-lg">
//               <Plus className="w-7 h-7 text-primary" />
//             </div>
//             <span className="text-sm font-semibold">Add Another Graph</span>
//             <span className="text-xs text-gray-500">{4 - graphs?.length} more graph{4 - graphs?.length !== 1 ? 's' : ''} available</span>
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PrimaryGraphCard;





// import React, { useState, useEffect } from 'react';
// import {
//   Plus,
//   Trash2,
//   Calendar,
//   ChevronDown,
//   BarChart3,
//   LineChart as LineChartIcon,
//   Download
// } from 'lucide-react';
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Legend
// } from 'recharts';
// import Button from '../../../components/ui/Button';
// import api from '../../../api/axios'; // ✅ axios instance

// /* ====================== CONSTANT MAPS ====================== */

// const METRIC_MAP = {
//   'Total Calls': 'TOTAL_CALLS',
//   'Total Minutes': 'TOTAL_MINUTES',
//   'Avg Call Duration': 'AVG_CALL_DURATION',
//   'Unique Customers': 'UNIQUE_CUSTOMERS',
//   'Tickets Raised': 'TICKETS_RAISED',
//   'Emails Sent': 'EMAILS_SENT',
//   'Human Escalation %': 'HUMAN_ESCALATION_PERCENT',
//   'Human Escalation Volume': 'HUMAN_ESCALATION_VOLUME',
//   'AI Resolution Rate': 'AI_RESOLUTION_RATE',
//   'Avg Response Time': 'AVG_RESPONSE_TIME',
//   'Customer Satisfaction': 'CUSTOMER_SATISFACTION'
// };

// const BREAKDOWN_MAP = {
//   Day: 'DAY',
//   Week: 'WEEK',
//   Month: 'MONTH',
//   Year: 'YEAR'
// };

// /* ====================== DATE UTILS ====================== */

// const getFromToDates = (selection, customStart, customEnd) => {
//   const now = new Date();
//   let from = new Date();
//   let to = new Date();

//   switch (selection) {
//     case 'Today':
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     case 'Yesterday':
//       from.setDate(now.getDate() - 1);
//       to.setDate(now.getDate() - 1);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     case 'Last 7 Days':
//       from.setDate(now.getDate() - 6);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     case 'Last 14 Days':
//       from.setDate(now.getDate() - 13);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     case 'Last Month':
//       from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//       to = new Date(now.getFullYear(), now.getMonth(), 0);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     case 'Custom Range':
//       if (!customStart || !customEnd) return null;
//       from = new Date(customStart);
//       to = new Date(customEnd);
//       from.setHours(0, 0, 0, 0);
//       to.setHours(23, 59, 59, 999);
//       break;

//     default:
//       return null;
//   }

//   const format = (d) => d.toISOString().split('.')[0];
//   return { from: format(from), to: format(to) };
// };

// /* ====================== COMPONENT ====================== */

// const PrimaryGraphCard = () => {
//   const [graphs, setGraphs] = useState([
//     { id: 1, metric: 'Total Calls', chartType: 'line', breakdown: 'Day' }
//   ]);
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showDateDropdown, setShowDateDropdown] = useState(false);
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [graphData, setGraphData] = useState({});
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   /* ====================== API ====================== */

//   const fetchGraphData = async (graph, filter, start, end) => {
//     try {
//       const metric = METRIC_MAP[graph.metric];
//       const breakdown = BREAKDOWN_MAP[graph.breakdown];
//       const range = getFromToDates(filter, start, end);

//       if (!range) return [];

//       const res = await api.get('/api/v1/dashboard/metrics', {
//         params: {
//           from: range.from,
//           to: range.to,
//           breakdown,
//           merchantId: 'M26686IMS',
//           metric
//         }
//       });

//       return Array.isArray(res?.data?.data?.data)
//         ? res.data.data.data
//         : [];
//     } catch (err) {
//       console.error('Graph fetch failed:', err);
//       return [];
//     }
//   };

//   /* ====================== EFFECT ====================== */

//   useEffect(() => {
//     const loadGraphs = async () => {
//       const result = {};

//       for (const graph of graphs) {
//         result[graph.id] = await fetchGraphData(
//           graph,
//           dateFilter,
//           customStartDate,
//           customEndDate
//         );
//       }

//       setGraphData(result);
//     };

//     loadGraphs();
//   }, [
//     graphs.map(g => `${g.metric}-${g.breakdown}`).join('|'),
//     dateFilter,
//     customStartDate,
//     customEndDate
//   ]);

//   /* ====================== UI (UNCHANGED) ====================== */

//   return (
//     <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 shadow-lg p-6 mb-6 md:mb-8 hover:shadow-xl transition-all duration-300">
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
//         <div>
//           <h2 className="text-xl font-semibold text-foreground mb-1">Primary Graph Analytics</h2>
//           <p className="text-sm text-muted-foreground">Visualize key metrics with customizable breakdowns</p>
//         </div>
        
//         <div className="flex items-center gap-3">
//           <button
//             onClick={handleDownloadReport}
//             className="flex items-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md"
//           >
//             <Download className="w-4 h-4" />
//             <span>Download Report</span>
//           </button>
          
//           <div className="relative">
//             <button
//               onClick={() => setShowDateDropdown(!showDateDropdown)}
//               className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-primary transition-all duration-200 text-sm font-medium text-foreground shadow-sm hover:shadow-md"
//             >
//               <Calendar className="w-4 h-4 text-primary" />
//               <span>{dateFilter}</span>
//               <ChevronDown className="w-4 h-4 text-muted-foreground" />
//             </button>
            
//             {showDateDropdown && (
//               <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden animate-fadeIn">
//                 {dateFilterOptions?.map((option) => (
//                   <button
//                     key={option}
//                     onClick={() => handleDateFilterChange(option)}
//                     className={`w-full text-left px-4 py-2.5 text-sm hover:bg-blue-50 transition-colors ${
//                       dateFilter === option ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-foreground'
//                     }`}
//                   >
//                     {option}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       {showCustomRange && (
//         <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 animate-fadeIn">
//           <div className="flex flex-col md:flex-row gap-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium text-foreground mb-2">Start Date</label>
//               <input
//                 type="date"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                         value={customStartDate}
//           onChange={(e) => setCustomStartDate(e.target.value)}
//               />
//             </div>
//             <div className="flex-1">
//               <label className="block text-sm font-medium text-foreground mb-2">End Date</label>
//               <input
//                 type="date"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
//                value={customEndDate}
//           onChange={(e) => setCustomEndDate(e.target.value)}
//               />
//             </div>
//             <div className="flex items-end">
//               <Button className="px-6 shadow-md hover:shadow-lg transition-shadow"
//                         onClick={() => {
//             // Re-fetch graphs with the custom range
//             graphs.forEach(async (graph) => {
//               const data = await fetchGraphData(graph, 'Custom Range', customStartDate, customEndDate);
//               setGraphData(prev => ({ ...prev, [graph.id]: data }));
//             });
//             setShowCustomRange(false);
//           }}
//               >
//                 Apply</Button>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="space-y-6">
//         {graphs?.map((graph, index) => (
//           <div
//             key={graph?.id}
//             className="bg-white rounded-lg border border-gray-200 p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:border-primary"
//           >
//             <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-5">
//               <div className="flex items-center gap-3">
//                 <select
//                   value={graph?.metric}
//                   onChange={(e) => handleMetricChange(graph?.id, e?.target?.value)}
//                   className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm font-medium bg-white hover:border-primary transition-all cursor-pointer shadow-sm"
//                 >
//                   {metricOptions?.map((metric) => (
//                     <option key={metric} value={metric}>{metric}</option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex items-center gap-3">
//                 <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
//                   {breakdownOptions?.map((option) => (
//                     <button
//                       key={option}
//                       onClick={() => handleBreakdownChange(graph?.id, option)}
//                       className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
//                         graph?.breakdown === option
//                           ? 'bg-primary text-white shadow-md'
//                           : 'text-gray-600 hover:bg-gray-200'
//                       }`}
//                     >
//                       {option}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => handleChartTypeToggle(graph?.id)}
//                   className="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-lg hover:from-blue-600 hover:to-indigo-600 transition-all duration-200 text-sm font-medium shadow-md hover:shadow-lg"
//                 >
//                   {graph?.chartType === 'line' ? (
//                     <><LineChartIcon className="w-4 h-4" /> Line</>
//                   ) : (
//                     <><BarChart3 className="w-4 h-4" /> Bar</>
//                   )}
//                 </button>

//                 {graphs?.length > 1 && (
//                   <button
//                     onClick={() => handleDeleteGraph(graph?.id)}
//                     className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200 hover:shadow-md"
//                     title="Delete Graph"
//                   >
//                     <Trash2 className="w-4 h-4" />
//                   </button>
//                 )}
//               </div>
//             </div>

//             <div className="h-80">
//               <ResponsiveContainer width="100%" height="100%">
//                 {graph?.chartType === 'line' ? (
//                   <LineChart data={graphData[graph.id] || []}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis 
//                       dataKey="period" 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <YAxis 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <Tooltip 
//                       contentStyle={{
//                         backgroundColor: 'white',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '8px',
//                         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//                       }}
//                     />
//                     <Legend />
//                     <Line 
//                       type="monotone" 
//                       dataKey="value" 
//                       stroke="#3b82f6" 
//                       strokeWidth={3}
//                       dot={{ fill: '#3b82f6', r: 5 }}
//                       activeDot={{ r: 7, fill: '#1e40af' }}
//                       name={graph?.metric}
//                     />
//                   </LineChart>
//                 ) : (
//                   <BarChart data={graphData[graph.id] || []}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis 
//                       dataKey="period" 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <YAxis 
//                       stroke="#6b7280" 
//                       style={{ fontSize: '12px', fontWeight: 500 }}
//                     />
//                     <Tooltip 
//                       contentStyle={{
//                         backgroundColor: 'white',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '8px',
//                         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//                       }}
//                     />
//                     <Legend />
//                     <Bar 
//                       dataKey="value" 
//                       fill="#3b82f6" 
//                       radius={[8, 8, 0, 0]}
//                       name={graph?.metric}
//                     />
//                   </BarChart>
//                 )}
//               </ResponsiveContainer>
//             </div>
//           </div>
//         ))}

//         {graphs?.length < 4 && (
//           <button
//             onClick={handleAddGraph}
//             className="w-full p-6 rounded-lg border-2 border-dashed border-gray-300 hover:border-primary hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-300 flex flex-col items-center justify-center gap-3 text-muted-foreground hover:text-primary group"
//           >
//             <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center group-hover:from-blue-200 group-hover:to-indigo-200 transition-all duration-300 shadow-md group-hover:shadow-lg">
//               <Plus className="w-7 h-7 text-primary" />
//             </div>
//             <span className="text-sm font-semibold">Add Another Graph</span>
//             <span className="text-xs text-gray-500">{4 - graphs?.length} more graph{4 - graphs?.length !== 1 ? 's' : ''} available</span>
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PrimaryGraphCard;






import React, { useState, useEffect, useRef } from 'react';
import {
  Plus,
  Trash2,
  Calendar,
  ChevronDown,
  BarChart3,
  LineChart as LineChartIcon,
  Download
} from 'lucide-react';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import api from '../../../api/axios';

/* ====================== CONSTANTS ====================== */

const dateFilterOptions = [
  'Today',
  'Yesterday',
  'Last 7 Days',
  'Last 14 Days',
  'Last Month',
  'Custom Range'
];

const DEFAULT_METRIC_OPTIONS = [{ value: 'TOTAL_CALLS', label: 'Total Calls' }];
const DEFAULT_BREAKDOWN_OPTIONS = [
  { value: 'DAY', label: 'Day' },
  { value: 'WEEK', label: 'Week' },
  { value: 'MONTH', label: 'Month' },
  { value: 'YEAR', label: 'Year' }
];

/* ====================== DATE UTILS ====================== */

const getFromToDates = (selection, customStart, customEnd) => {
  const now = new Date();
  let from = new Date();
  let to = new Date();

  switch (selection) {
    case 'Today':
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Yesterday':
      from.setDate(now.getDate() - 1);
      to.setDate(now.getDate() - 1);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Last 7 Days':
      from.setDate(now.getDate() - 6);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Last 14 Days':
      from.setDate(now.getDate() - 13);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Last Month':
      from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      to = new Date(now.getFullYear(), now.getMonth(), 0);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    case 'Custom Range':
      if (!customStart || !customEnd) return null;
      from = new Date(customStart);
      to = new Date(customEnd);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;

    default:
      return null;
  }

  const format = (d) => d.toISOString().split('.')[0];
  return { from: format(from), to: format(to) };
};

/* ====================== COMPONENT ====================== */

const PrimaryGraphCard = () => {
  const [graphs, setGraphs] = useState([
    { id: 1, metric: 'TOTAL_CALLS', chartType: 'line', breakdown: 'DAY' }
  ]);
  const [dateFilter, setDateFilter] = useState('Last 7 Days');
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [graphData, setGraphData] = useState({});
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [metricOptions, setMetricOptions] = useState(DEFAULT_METRIC_OPTIONS);
  const [breakdownOptions, setBreakdownOptions] = useState(DEFAULT_BREAKDOWN_OPTIONS);

  // Agent filter - independent for this widget
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');

  // Preference persistence
  const saveTimerRef = useRef(null);

  useEffect(() => {
    api.get('/api/v1/dashboard/get-agents')
      .then((res) => {
        const list = res.data?.data?.agents || [];
        setAgents(list);
      })
      .catch((err) => console.error('Failed to fetch agents:', err));

    // Fetch saved graph preferences on mount
    api.get('/api/v1/dashboard/preferences')
      .then((res) => {
        const prefs = res.data?.data;
        if (prefs?.graphConfigs?.length > 0) {
          const restored = prefs.graphConfigs.map((g, i) => ({
            id: Date.now() + i,
            metric: g.metric,
            chartType: g.chartType,
            breakdown: g.breakdown
          }));
          setGraphs(restored);
        }
      })
      .catch(() => {});
  }, []);

  /* ====================== FETCH OPTIONS ====================== */

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await api.get('/api/v1/dashboard/metric-options');
        if (res.data?.success && res.data?.data) {
          const { metrics, breakdowns } = res.data.data;
          if (metrics?.length) setMetricOptions(metrics);
          if (breakdowns?.length) setBreakdownOptions(breakdowns);
        }
      } catch (err) {
        console.error('Error fetching metric options:', err);
      }
    };
    fetchOptions();
  }, []);

  /* ====================== HELPERS ====================== */

  const getMetricLabel = (value) => metricOptions.find(m => m.value === value)?.label || value;
  const getBreakdownLabel = (value) => breakdownOptions.find(b => b.value === value)?.label || value;

  /* ====================== API ====================== */

  const fetchGraphData = async (graph, filter, start, end) => {
    try {
      const range = getFromToDates(filter, start, end);
      if (!range) return [];

      const params = {
          from: range.from,
          to: range.to,
          breakdown: graph.breakdown,
          metric: graph.metric
      };
      if (selectedAgent) params.agentId = selectedAgent;

      const res = await api.get('/api/v1/dashboard/metrics', { params });

      return res?.data?.data?.data || [];
    } catch (err) {
      console.error('Graph fetch failed:', err);
      return [];
    }
  };

  /* ====================== EFFECT ====================== */

  useEffect(() => {
    const load = async () => {
      const result = {};
      for (const g of graphs) {
        result[g.id] = await fetchGraphData(
          g,
          dateFilter,
          customStartDate,
          customEndDate
        );
      }
      setGraphData(result);
    };
    load();
  }, [
    graphs.map(g => `${g.metric}-${g.breakdown}`).join('|'),
    dateFilter,
    customStartDate,
    customEndDate,
    selectedAgent
  ]);

  /* ====================== PREFERENCE SAVE ====================== */

  const saveGraphPreferences = (graphList) => {
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => {
      const graphConfigs = graphList.map(g => ({
        metric: g.metric,
        chartType: g.chartType,
        breakdown: g.breakdown
      }));
      api.put('/api/v1/dashboard/preferences', { graphConfigs })
        .catch(err => console.error('Failed to save graph preferences:', err));
    }, 500);
  };

  /* ====================== HANDLERS ====================== */

  const handleAddGraph = () => {
    if (graphs.length < 4) {
      const updated = [...graphs, {
        id: Date.now(),
        metric: metricOptions[0]?.value || 'TOTAL_CALLS',
        chartType: 'line',
        breakdown: breakdownOptions[0]?.value || 'DAY'
      }];
      setGraphs(updated);
      saveGraphPreferences(updated);
    }
  };

  const handleDeleteGraph = (id) => {
    if (graphs.length > 1) {
      const updated = graphs.filter(g => g.id !== id);
      setGraphs(updated);
      saveGraphPreferences(updated);
    }
  };

  const handleMetricChange = (id, metric) => {
    const updated = graphs.map(g => g.id === id ? { ...g, metric } : g);
    setGraphs(updated);
    saveGraphPreferences(updated);
  };

  const handleBreakdownChange = (id, breakdown) => {
    const updated = graphs.map(g => g.id === id ? { ...g, breakdown } : g);
    setGraphs(updated);
    saveGraphPreferences(updated);
  };

  const handleChartTypeToggle = (id) => {
    const updated = graphs.map(g =>
      g.id === id
        ? { ...g, chartType: g.chartType === 'line' ? 'bar' : 'line' }
        : g
    );
    setGraphs(updated);
    saveGraphPreferences(updated);
  };

  const handleDateFilterChange = (option) => {
    setDateFilter(option);
    setShowCustomRange(option === 'Custom Range');
    setShowDateDropdown(false);
  };

  const handleDownloadReport = () => {
    const allPeriods = new Set();
    graphs.forEach(g => {
      (graphData[g.id] || []).forEach(d => allPeriods.add(d.period));
    });
    const periods = [...allPeriods].sort();
    if (periods.length === 0) return;

    const headers = ['Period', ...graphs.map(g => getMetricLabel(g.metric))];
    const csvRows = periods.map(period => {
      const row = [period];
      graphs.forEach(g => {
        const point = (graphData[g.id] || []).find(d => d.period === period);
        row.push(point?.value ?? '');
      });
      return row;
    });

    const csvContent = [headers, ...csvRows]
      .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `analytics-report-${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  /* ====================== UI ====================== */
  // 🔒 UI BELOW IS **UNCHANGED**

  return (
    <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl border border-gray-200 shadow-lg p-6 mb-6 md:mb-8 hover:shadow-xl transition-all duration-300">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-1">Primary Graph Analytics</h2>
          <p className="text-sm text-muted-foreground">Visualize key metrics with customizable breakdowns</p>
        </div>

        <div className="flex items-center gap-3">
          <Select
            options={[
              { value: '', label: 'All Agents' },
              ...agents.map(a => ({ value: a.agentId, label: a.agentName }))
            ]}
            value={selectedAgent}
            onChange={setSelectedAgent}
            placeholder="Select agent"
          />
          <button
            onClick={handleDownloadReport}
            className="flex items-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md"
          >
            <Download className="w-4 h-4" />
            <span>Download Report</span>
          </button>
          
          <div className="relative">
            <button
              onClick={() => setShowDateDropdown(!showDateDropdown)}
              className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-primary transition-all duration-200 text-sm font-medium text-foreground shadow-sm hover:shadow-md"
            >
              <Calendar className="w-4 h-4 text-primary" />
              <span>{dateFilter}</span>
              <ChevronDown className="w-4 h-4 text-muted-foreground" />
            </button>
            
            {showDateDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden animate-fadeIn">
                {dateFilterOptions?.map((option) => (
                  <button
                    key={option}
                    onClick={() => handleDateFilterChange(option)}
                    className={`w-full text-left px-4 py-2.5 text-sm hover:bg-blue-50 transition-colors ${
                      dateFilter === option ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-foreground'
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {showCustomRange && (
        <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 animate-fadeIn">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-foreground mb-2">Start Date</label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                        value={customStartDate}
          onChange={(e) => setCustomStartDate(e.target.value)}
              />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium text-foreground mb-2">End Date</label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
               value={customEndDate}
          onChange={(e) => setCustomEndDate(e.target.value)}
              />
            </div>
            <div className="flex items-end">
              <Button className="px-6 shadow-md hover:shadow-lg transition-shadow"
                        onClick={() => {
            // Re-fetch graphs with the custom range
            graphs.forEach(async (graph) => {
              const data = await fetchGraphData(graph, 'Custom Range', customStartDate, customEndDate);
              setGraphData(prev => ({ ...prev, [graph.id]: data }));
            });
            setShowCustomRange(false);
          }}
              >
                Apply</Button>
            </div>
          </div>
        </div>
      )}
      <div className="space-y-6">
        {graphs?.map((graph, index) => (
          <div
            key={graph?.id}
            className="bg-white rounded-lg border border-gray-200 p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:border-primary"
          >
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-5">
              <div className="flex items-center gap-3">
                <select
                  value={graph?.metric}
                  onChange={(e) => handleMetricChange(graph?.id, e?.target?.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm font-medium bg-white hover:border-primary transition-all cursor-pointer shadow-sm"
                >
                  {metricOptions?.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
                  {breakdownOptions?.map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => handleBreakdownChange(graph?.id, opt.value)}
                      className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                        graph?.breakdown === opt.value
                          ? 'bg-primary text-white shadow-md'
                          : 'text-gray-600 hover:bg-gray-200'
                      }`}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleChartTypeToggle(graph?.id)}
                  className="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-lg hover:from-blue-600 hover:to-indigo-600 transition-all duration-200 text-sm font-medium shadow-md hover:shadow-lg"
                >
                  {graph?.chartType === 'line' ? (
                    <><LineChartIcon className="w-4 h-4" /> Line</>
                  ) : (
                    <><BarChart3 className="w-4 h-4" /> Bar</>
                  )}
                </button>

                {graphs?.length > 1 && (
                  <button
                    onClick={() => handleDeleteGraph(graph?.id)}
                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200 hover:shadow-md"
                    title="Delete Graph"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>

            <div className="h-80">
              <ResponsiveContainer width="100%" height="100%">
                {graph?.chartType === 'line' ? (
                  <LineChart data={graphData[graph.id] || []}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis 
                      dataKey="period" 
                      stroke="#6b7280" 
                      style={{ fontSize: '12px', fontWeight: 500 }}
                    />
                    <YAxis 
                      stroke="#6b7280" 
                      style={{ fontSize: '12px', fontWeight: 500 }}
                    />
                    <Tooltip 
                      contentStyle={{
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                      }}
                    />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#3b82f6"
                      strokeWidth={3}
                      dot={{ fill: '#3b82f6', r: 5 }}
                      activeDot={{ r: 7, fill: '#1e40af' }}
                      name={getMetricLabel(graph?.metric)}
                    />
                  </LineChart>
                ) : (
                  <BarChart data={graphData[graph.id] || []}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis 
                      dataKey="period" 
                      stroke="#6b7280" 
                      style={{ fontSize: '12px', fontWeight: 500 }}
                    />
                    <YAxis 
                      stroke="#6b7280" 
                      style={{ fontSize: '12px', fontWeight: 500 }}
                    />
                    <Tooltip 
                      contentStyle={{
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                      }}
                    />
                    <Legend />
                    <Bar
                      dataKey="value"
                      fill="#3b82f6"
                      radius={[8, 8, 0, 0]}
                      name={getMetricLabel(graph?.metric)}
                    />
                  </BarChart>
                )}
              </ResponsiveContainer>
            </div>
          </div>
        ))}

        {graphs?.length < 4 && (
          <button
            onClick={handleAddGraph}
            className="w-full p-6 rounded-lg border-2 border-dashed border-gray-300 hover:border-primary hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-300 flex flex-col items-center justify-center gap-3 text-muted-foreground hover:text-primary group"
          >
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center group-hover:from-blue-200 group-hover:to-indigo-200 transition-all duration-300 shadow-md group-hover:shadow-lg">
              <Plus className="w-7 h-7 text-primary" />
            </div>
            <span className="text-sm font-semibold">Add Another Graph</span>
            <span className="text-xs text-gray-500">{4 - graphs?.length} more graph{4 - graphs?.length !== 1 ? 's' : ''} available</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default PrimaryGraphCard;


